import { forwardRef } from 'react'

import { Image } from '@/legacy/components/Image'
import type { MediaProps } from '@/legacy/components/Media'

import { usePartnerSearch } from '../core/PartnerSearchContext'
import { ButtonStyle, PartnerItemStyle } from '../styles'

type PartnerMidia = Omit<MediaProps, 'midia'> & {
  image: MediaProps['image']
}
export interface PartnerItemProps {
  midia: PartnerMidia
  link?: string
  width: number
  height: number
  name: string
  index?: number
}

const PartnerListItem = forwardRef<HTMLButtonElement, PartnerItemProps>(
  ({ name, midia, link, width = 120, height = 80, index }: PartnerItemProps, ref) => {
    const linkName = link?.split('/').pop()
    const namePartner = name ? name : linkName
    const refLink = index == 0 ? ref : null

    const { cardButtonLabel, concatenation } = usePartnerSearch()

    const concat = concatenation || 'com'
    const ariaLabel = `${cardButtonLabel} ${concat} ${namePartner}`

    return (
      <PartnerItemStyle>
        {midia && midia.image?.url && (
          <>
            <div className="image">
              <Image
                data={midia.image}
                width={width}
                height={height}
                alt={midia.image?.alt}
                layout="responsive"
                aria-hidden={!!link}
              />
            </div>
            {cardButtonLabel && (
              <ButtonStyle
                className="linkPartner"
                event={{
                  label: cardButtonLabel,
                  customProps: { parceiro: namePartner as string },
                }}
                source={link}
                tabIndex={0}
                ref={refLink}
                aria-label={ariaLabel}
                modifier="solid"
              >
                {cardButtonLabel}
              </ButtonStyle>
            )}
          </>
        )}
      </PartnerItemStyle>
    )
  },
)

PartnerListItem.displayName = 'PartnerListItem'
export default PartnerListItem
